import React, { useState } from "react";
import { CustomInputProps } from "./type";
import "./style.scss";
import { baseUrl } from "src/request/types";
import { useTranslation } from "react-i18next";
import Lightbox from "react-image-lightbox";
import images from "src/assets/image";

/**
 * Yeni nesil dosya alanı: üstte etiket + belirgin dosya seçici + mevcut dosya
 * önizlemeleri. (Eski floating FormGroup atıldı.)
 */
const CustomFileInputProps = ({
  currentFileLinks,
  currentFiles,
  multiple,
  label,
  error,
  name,
  touched,
  options,
  placeholder,
  value,
  labelProps,
  className,
  accept,
  onChange,
  valueRenderer,
  disabled,
  ...props
}: CustomInputProps) => {
  const { t } = useTranslation();
  const [isEffects, setisEffects] = useState<string>();
  const invalid = !!(error && touched);
  return (
    <div className={"m-field " + (className ?? "")}>
      {label && (
        <label className="m-field__label" htmlFor={name} {...labelProps}>
          {label}
        </label>
      )}
      <input
        id={name}
        placeholder={placeholder}
        accept={accept}
        name={name}
        multiple={multiple}
        disabled={disabled}
        type={"file"}
        className={"m-file" + (invalid ? " is-invalid" : "")}
        onChange={(e) => {
          if (multiple) {
            onChange && onChange(e.target.files);
          } else {
            onChange &&
              (e.target.files && e.target.files.length > 0
                ? onChange(e.target.files[0])
                : onChange(""));
          }
        }}
      />
      {invalid && <div className="m-field__error">{error}</div>}

      {isEffects ? (
        <Lightbox
          mainSrc={baseUrl + isEffects}
          enableZoom={true}
          onCloseRequest={() => {
            setisEffects(undefined);
          }}
        />
      ) : null}

      {!valueRenderer && currentFileLinks && currentFileLinks.length > 0 && (
        <div className="m-file__previews">
          <div className="m-file__previews-title">
            {t("FileComponent.CurrentFiles")}
          </div>
          <div className="m-file__thumbs">
            {currentFileLinks?.map((key, i) => (
              <img
                key={i}
                className="m-file__thumb"
                src={baseUrl + key}
                alt=""
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = images.doc;
                }}
                onClick={() => {
                  if (key.includes("png" || "jpg" || "jpeg" || "svg")) {
                    setisEffects(key);
                  } else {
                    window.open(baseUrl + key, "_blank");
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}

      {valueRenderer && valueRenderer()}
    </div>
  );
};
export default CustomFileInputProps;
